import { UTCDate } from '@/utils/dates';
import { CsvDownloadConfig } from '../../../../design-system/data-table/csv-download/types/csv-download-config';
import { TransactionView } from '../../../../types/entity-types';

export const transactionsCsvConfig: CsvDownloadConfig<TransactionView> = {
  show: true,
  filename: 'transactions.csv',
  columns: [
    { key: 'id', header: 'Transaction ID', accessor: (row) => row.id },
    {
      key: 'fspDate',
      header: 'Transaction Date',
      accessor: (row) => row.fspDate,
      formatter: (value) => {
        if (typeof value === 'string' || value instanceof Date) {
          return new UTCDate(value).toLocaleDateString('en-GB');
        }
        return String(value);
      },
    },
    { key: 'description', header: 'Description', accessor: (row) => row.description || '' },
    {
      key: 'amount',
      header: 'Amount',
      accessor: (row) => row.amount,
      formatter: (value) => {
        if (typeof value === 'number') {
          return value.toFixed(2);
        }
        return String(value);
      },
    },
    { key: 'currency', header: 'Currency', accessor: (row) => row.currency },
    { key: 'type', header: 'Type', accessor: (row) => row.type },
    { key: 'status', header: 'Status', accessor: (row) => row.status },
    { key: 'categoryName', header: 'Category', accessor: (row) => row.vendor?.category?.level2 || '' },
    { key: 'accountName', header: 'Account', accessor: (row) => row.account?.displayName || '' },
    { key: 'vendorName', header: 'Vendor', accessor: (row) => row.vendor?.name || '' },
    { key: 'reference', header: 'Reference', accessor: (row) => row.reference || '' },
  ],
};
